import React, { useEffect, useState } from "react";
// Import Highcharts
import Highcharts from "highcharts/highstock";
//import HighchartsReact from "./HighchartsReact.js";
import PieChart from "highcharts-react-official";
import Sidebar from "../../Sidebar/Sidebar";
import Header from "../Header/Header";
const Dashboard = () => {
  // Set up the chart configuration options

  const chartOptions = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Eyes and Lens",
    },
    series: [
      {
        name: "Eye and Lens",
        data: [
          { name: "Eye", y: 50 },
          { name: "Contact Lens", y: 30 },
          { name: "Tom Ford", y: 20 },
          { name: "LensX", y: 70 },
          { name: "John Smith", y: 80 },
        ],
      },
    ],

    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          // format: '<b>{point.name}</b>: {point.percentage} ',
        },
      },
    },
  };

  let patientIcon = (
    <svg
      width="131"
      height="131"
      viewBox="0 0 131 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="65.5" cy="65.5" r="62.5" stroke="#4C004A" stroke-width="6" />
      <path
        d="M88.5 63.75H59.25C58.6533 63.75 58.081 63.9871 57.659 64.409C57.2371 64.831 57 65.4033 57 66V75H39V52.5C39 51.9033 38.7629 51.331 38.341 50.909C37.919 50.4871 37.3467 50.25 36.75 50.25C36.1533 50.25 35.581 50.4871 35.159 50.909C34.7371 51.331 34.5 51.9033 34.5 52.5V86.25C34.5 86.8467 34.7371 87.419 35.159 87.841C35.581 88.2629 36.1533 88.5 36.75 88.5C37.3467 88.5 37.919 88.2629 38.341 87.841C38.7629 87.419 39 86.8467 39 86.25V79.5H93V86.25C93 86.8467 93.2371 87.419 93.659 87.841C94.081 88.2629 94.6533 88.5 95.25 88.5C95.8467 88.5 96.419 88.2629 96.841 87.841C97.2629 87.419 97.5 86.8467 97.5 86.25V72.75C97.4975 70.3638 96.5485 68.0761 94.8612 66.3888C93.1739 64.7015 90.8862 63.7525 88.5 63.75Z"
        fill="#4C004A"
      />
      <path
        d="M48 75C51.7279 75 54.75 71.9779 54.75 68.25C54.75 64.5221 51.7279 61.5 48 61.5C44.2721 61.5 41.25 64.5221 41.25 68.25C41.25 71.9779 44.2721 75 48 75Z"
        fill="#4C004A"
      />
      <path
        d="M66 34.5C65.4033 34.5 64.831 34.7371 64.409 35.159C63.9871 35.581 63.75 36.1533 63.75 36.75V41.25H59.25C58.6533 41.25 58.081 41.4871 57.659 41.909C57.2371 42.331 57 42.9033 57 43.5C57 44.0967 57.2371 44.669 57.659 45.091C58.081 45.5129 58.6533 45.75 59.25 45.75H63.75V50.25C63.75 50.8467 63.9871 51.419 64.409 51.841C64.831 52.2629 65.4033 52.5 66 52.5C66.5967 52.5 67.169 52.2629 67.591 51.841C68.0129 51.419 68.25 50.8467 68.25 50.25V45.75H72.75C73.3467 45.75 73.919 45.5129 74.341 45.091C74.7629 44.669 75 44.0967 75 43.5C75 42.9033 74.7629 42.331 74.341 41.909C73.919 41.4871 73.3467 41.25 72.75 41.25H68.25V36.75C68.25 36.1533 68.0129 35.581 67.591 35.159C67.169 34.7371 66.5967 34.5 66 34.5Z"
        fill="#4C004A"
      />
    </svg>
  );
  let patientTodayIcon = (
    <svg
      width="131"
      height="131"
      viewBox="0 0 131 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_0_1)">
        <path
          d="M82.2188 58.8868H81.8742C80.7411 58.883 79.6206 58.648 78.5814 58.1963C77.5422 57.7446 76.606 57.0857 75.8302 56.2598C73.4918 57.961 70.6759 58.8804 67.7841 58.8868H64.5C63.9779 58.8868 63.4771 58.6794 63.1079 58.3102C62.7387 57.941 62.5312 57.4402 62.5312 56.9181C62.5312 56.3959 62.7387 55.8952 63.1079 55.526C63.4771 55.1568 63.9779 54.9493 64.5 54.9493H67.7841C69.0881 54.9464 70.3784 54.6824 71.5787 54.1729C72.7791 53.6634 73.8652 52.9187 74.7732 51.9827C74.9931 51.7543 75.2649 51.5824 75.5655 51.4816C75.8661 51.3807 76.1866 51.354 76.4998 51.4037C76.8129 51.4533 77.1094 51.5779 77.3641 51.7667C77.6188 51.9556 77.8241 52.2032 77.9626 52.4884C78.319 53.2235 78.8746 53.8439 79.5661 54.2789C80.2576 54.7139 81.0573 54.9462 81.8742 54.9493H82.2188C82.7409 54.9493 83.2417 55.1568 83.6109 55.526C83.9801 55.8952 84.1875 56.3959 84.1875 56.9181C84.1875 57.4402 83.9801 57.941 83.6109 58.3102C83.2417 58.6794 82.7409 58.8868 82.2188 58.8868Z"
          fill="#4C004A"
        />
        <path
          d="M73.3594 75.1289C70.4886 75.1256 67.7363 73.9838 65.7063 71.9538C63.6764 69.9239 62.5345 67.1716 62.5312 64.3008V56.918C62.5312 56.3958 62.7387 55.8951 63.1079 55.5259C63.4771 55.1566 63.9779 54.9492 64.5 54.9492C65.0221 54.9492 65.5229 55.1566 65.8921 55.5259C66.2613 55.8951 66.4688 56.3958 66.4688 56.918V64.3008C66.4688 66.1283 67.1947 67.8809 68.487 69.1732C69.7792 70.4654 71.5319 71.1914 73.3594 71.1914C75.1869 71.1914 76.9395 70.4654 78.2318 69.1732C79.524 67.8809 80.25 66.1283 80.25 64.3008V56.918C80.25 56.3958 80.4574 55.8951 80.8266 55.5259C81.1958 55.1566 81.6966 54.9492 82.2188 54.9492C82.7409 54.9492 83.2417 55.1566 83.6109 55.5259C83.9801 55.8951 84.1875 56.3958 84.1875 56.918V64.3008C84.1842 67.1716 83.0424 69.9239 81.0124 71.9538C78.9825 73.9838 76.2302 75.1256 73.3594 75.1289V75.1289Z"
          fill="#4C004A"
        />
        <path
          d="M64.5 66.7617H62.2852C60.7187 66.7617 59.2164 66.1395 58.1088 65.0318C57.0012 63.9242 56.3789 62.4219 56.3789 60.8555C56.3789 59.289 57.0012 57.7868 58.1088 56.6791C59.2164 55.5715 60.7187 54.9492 62.2852 54.9492H64.5C65.0221 54.9492 65.5229 55.1566 65.8921 55.5259C66.2613 55.8951 66.4688 56.3958 66.4688 56.918V64.793C66.4688 65.3151 66.2613 65.8159 65.8921 66.1851C65.5229 66.5543 65.0221 66.7617 64.5 66.7617ZM62.2852 58.8867C61.763 58.8867 61.2623 59.0941 60.893 59.4634C60.5238 59.8326 60.3164 60.3333 60.3164 60.8555C60.3164 61.3776 60.5238 61.8784 60.893 62.2476C61.2623 62.6168 61.763 62.8242 62.2852 62.8242H62.5312V58.8867H62.2852ZM84.4336 66.7617H82.2188C81.6966 66.7617 81.1958 66.5543 80.8266 66.1851C80.4574 65.8159 80.25 65.3151 80.25 64.793V56.918C80.25 56.3958 80.4574 55.8951 80.8266 55.5259C81.1958 55.1566 81.6966 54.9492 82.2188 54.9492H84.4336C86 54.9492 87.5023 55.5715 88.6099 56.6791C89.7176 57.7868 90.3398 59.289 90.3398 60.8555C90.3398 62.4219 89.7176 63.9242 88.6099 65.0318C87.5023 66.1395 86 66.7617 84.4336 66.7617V66.7617ZM84.1875 62.8242H84.4336C84.9557 62.8242 85.4565 62.6168 85.8257 62.2476C86.1949 61.8784 86.4023 61.3776 86.4023 60.8555C86.4023 60.3333 86.1949 59.8326 85.8257 59.4634C85.4565 59.0941 84.9557 58.8867 84.4336 58.8867H84.1875V62.8242Z"
          fill="#4C004A"
        />
        <path
          d="M86.0333 59.2252C85.5111 59.2252 85.0104 59.0178 84.6411 58.6486C84.2719 58.2794 84.0645 57.7786 84.0645 57.2565V51.2579C84.0645 50.4864 83.8226 49.7343 83.3731 49.1072C82.9235 48.4802 82.2888 48.0098 81.558 47.7622L77.7731 46.4776C77.3053 46.3195 76.914 45.9914 76.6768 45.5584C76.4395 45.1254 76.3736 44.619 76.4922 44.1397L76.9844 42.1488C75.5337 42.1488 75.9693 42.134 75.0267 42.2078C73.6038 42.3191 72.2223 42.739 70.9781 43.4383C69.7339 44.1377 68.6571 45.0996 67.8223 46.2573C67.5644 46.6139 67.1945 46.8739 66.7715 46.9956L65.3232 47.4139C64.5553 47.6382 63.8804 48.1049 63.3994 48.7442C62.9184 49.3836 62.657 50.1613 62.6544 50.9614V57.2565C62.6544 57.7786 62.4469 58.2794 62.0777 58.6486C61.7085 59.0178 61.2077 59.2252 60.6856 59.2252C60.1635 59.2252 59.6627 59.0178 59.2935 58.6486C58.9243 58.2794 58.7169 57.7786 58.7169 57.2565V50.9614C58.7221 49.3084 59.2616 47.7013 60.2548 46.3799C61.248 45.0586 62.6417 44.0936 64.2281 43.629L65.0513 43.3915C66.228 41.9262 67.6923 40.7173 69.3539 39.8393C71.0156 38.9613 72.8393 38.4328 74.7129 38.2863C75.9188 38.1916 74.8766 38.215 79.4921 38.215C79.7909 38.2145 80.0858 38.2821 80.3546 38.4126C80.6234 38.5431 80.8589 38.733 81.0434 38.968C81.2279 39.203 81.3565 39.4769 81.4195 39.769C81.4824 40.061 81.478 40.3636 81.4067 40.6537L80.7484 43.3288L82.8205 44.0314C84.3318 44.5421 85.6448 45.5142 86.5744 46.8107C87.504 48.1071 88.0033 49.6626 88.002 51.2579V57.2577C88.0017 57.7796 87.7941 58.2801 87.4249 58.649C87.0558 59.018 86.5552 59.2252 86.0333 59.2252ZM94.0313 99.0001H56.6251C55.0591 98.9985 53.5578 98.3757 52.4505 97.2684C51.3432 96.1611 50.7204 94.6598 50.7188 93.0939V84.1951C50.7122 82.4651 51.2965 80.7847 52.375 79.4321C53.4535 78.0795 54.9616 77.1357 56.6497 76.7569L66.3458 74.5421V71.5607C66.3458 71.0385 66.5532 70.5378 66.9224 70.1685C67.2916 69.7993 67.7924 69.5919 68.3145 69.5919C68.8367 69.5919 69.3374 69.7993 69.7066 70.1685C70.0758 70.5378 70.2833 71.0385 70.2833 71.5607V76.1134C70.2833 76.5594 70.1319 76.9923 69.8538 77.341C69.5757 77.6897 69.1874 77.9337 68.7526 78.0329L57.5258 80.596C56.7089 80.7791 55.9791 81.2358 55.4573 81.8903C54.9355 82.5448 54.6529 83.358 54.6563 84.1951V93.0939C54.6563 93.616 54.8637 94.1168 55.2329 94.486C55.6022 94.8552 56.1029 95.0626 56.6251 95.0626H92.0626V84.1951C92.066 83.358 91.7834 82.5448 91.2616 81.8903C90.7397 81.2358 90.0099 80.7791 89.1931 80.596L77.9663 78.0329C77.5315 77.9337 77.1432 77.6897 76.8651 77.341C76.587 76.9923 76.4356 76.5594 76.4356 76.1134V71.5607C76.4356 71.0385 76.643 70.5378 77.0122 70.1685C77.3814 69.7993 77.8822 69.5919 78.4044 69.5919C78.9265 69.5919 79.4273 69.7993 79.7965 70.1685C80.1657 70.5378 80.3731 71.0385 80.3731 71.5607V74.5433L90.0692 76.7582C91.757 77.1368 93.265 78.0805 94.3435 79.4329C95.422 80.7852 96.0064 82.4653 96.0001 84.1951V97.0314C96.0001 97.5535 95.7926 98.0543 95.4234 98.4235C95.0542 98.7927 94.5535 99.0001 94.0313 99.0001Z"
          fill="#4C004A"
        />
        <path
          d="M73.3594 83.25C71.4619 83.2568 69.6066 82.6908 68.0361 81.626C66.4655 80.5613 65.2528 79.0473 64.5566 77.2822C64.3636 76.797 64.3712 76.2549 64.5779 75.7753C64.7845 75.2956 65.1732 74.9177 65.6585 74.7247C66.1438 74.5317 66.6858 74.5393 67.1655 74.746C67.6451 74.9526 68.023 75.3413 68.216 75.8266C68.6263 76.8555 69.3357 77.7377 70.2526 78.3592C71.1695 78.9808 72.2517 79.313 73.3594 79.313C74.4671 79.313 75.5493 78.9808 76.4662 78.3592C77.3831 77.7377 78.0925 76.8555 78.5027 75.8266C78.5983 75.5863 78.7403 75.3672 78.9205 75.1818C79.1008 74.9964 79.3158 74.8483 79.5533 74.746C79.7908 74.6436 80.0461 74.5891 80.3047 74.5855C80.5632 74.5818 80.82 74.6291 81.0603 74.7247C81.3005 74.8203 81.5196 74.9622 81.7051 75.1425C81.8905 75.3228 82.0386 75.5378 82.1409 75.7753C82.2432 76.0127 82.2977 76.2681 82.3014 76.5266C82.305 76.7852 82.2577 77.0419 82.1621 77.2822C81.4659 79.0473 80.2533 80.5613 78.6827 81.626C77.1121 82.6908 75.2568 83.2568 73.3594 83.25V83.25ZM48.2578 60.8555H38.9062C37.3403 60.8538 35.839 60.2311 34.7317 59.1238C33.6244 58.0165 33.0016 56.5152 33 54.9492V37.9688C33 37.4466 33.2074 36.9458 33.5766 36.5766C33.9458 36.2074 34.4466 36 34.9688 36H52.1953C52.7175 36 53.2182 36.2074 53.5874 36.5766C53.9566 36.9458 54.1641 37.4466 54.1641 37.9688V54.9492C54.1624 56.5152 53.5396 58.0165 52.4324 59.1238C51.3251 60.2311 49.8237 60.8538 48.2578 60.8555V60.8555ZM36.9375 39.9375V54.9492C36.9375 55.4714 37.1449 55.9721 37.5141 56.3413C37.8833 56.7105 38.3841 56.918 38.9062 56.918H48.2578C48.78 56.918 49.2807 56.7105 49.6499 56.3413C50.0191 55.9721 50.2266 55.4714 50.2266 54.9492V39.9375H36.9375Z"
          fill="#4C004A"
        />
        <path
          d="M64.5 91.3711C63.9779 91.3711 63.4771 91.1637 63.1079 90.7945C62.7387 90.4252 62.5312 89.9245 62.5312 89.4023V86.2031C62.5312 85.9421 62.4275 85.6917 62.2429 85.5071C62.0583 85.3225 61.8079 85.2188 61.5469 85.2188H46.5352C45.2298 85.2188 43.9779 84.7002 43.0549 83.7772C42.1318 82.8541 41.6133 81.6022 41.6133 80.2969V58.8867C41.6133 58.3646 41.8207 57.8638 42.1899 57.4946C42.5591 57.1254 43.0599 56.918 43.582 56.918C44.1042 56.918 44.6049 57.1254 44.9741 57.4946C45.3434 57.8638 45.5508 58.3646 45.5508 58.8867V80.2969C45.5508 80.5579 45.6545 80.8083 45.8391 80.9929C46.0237 81.1775 46.2741 81.2812 46.5352 81.2812H61.5469C62.8522 81.2812 64.1041 81.7998 65.0272 82.7228C65.9502 83.6459 66.4688 84.8978 66.4688 86.2031V89.4023C66.4688 89.9245 66.2613 90.4252 65.8921 90.7945C65.5229 91.1637 65.0221 91.3711 64.5 91.3711ZM52.1953 51.75H34.9688C34.4466 51.75 33.9458 51.5426 33.5766 51.1734C33.2074 50.8042 33 50.3034 33 49.7812C33 49.2591 33.2074 48.7583 33.5766 48.3891C33.9458 48.0199 34.4466 47.8125 34.9688 47.8125H52.1953C52.7175 47.8125 53.2182 48.0199 53.5874 48.3891C53.9566 48.7583 54.1641 49.2591 54.1641 49.7812C54.1641 50.3034 53.9566 50.8042 53.5874 51.1734C53.2182 51.5426 52.7175 51.75 52.1953 51.75Z"
          fill="#4C004A"
        />
        <path
          d="M70.4062 99H60.9316C60.4095 99 59.9087 98.7926 59.5395 98.4234C59.1703 98.0542 58.9629 97.5534 58.9629 97.0312C58.9629 96.5091 59.1703 96.0083 59.5395 95.6391C59.9087 95.2699 60.4095 95.0625 60.9316 95.0625H70.4062C70.8958 95.0625 71.3652 94.868 71.7114 94.5219C72.0575 94.1758 72.252 93.7063 72.252 93.2168C72.252 92.7273 72.0575 92.2578 71.7114 91.9117C71.3652 91.5656 70.8958 91.3711 70.4062 91.3711H60.9316C60.4095 91.3711 59.9087 91.1637 59.5395 90.7945C59.1703 90.4252 58.9629 89.9245 58.9629 89.4023C58.9629 88.8802 59.1703 88.3794 59.5395 88.0102C59.9087 87.641 60.4095 87.4336 60.9316 87.4336H70.4062C71.9401 87.4336 73.411 88.0429 74.4956 89.1275C75.5802 90.212 76.1895 91.683 76.1895 93.2168C76.1895 94.7506 75.5802 96.2216 74.4956 97.3061C73.411 98.3907 71.9401 99 70.4062 99Z"
          fill="#4C004A"
        />
        <path
          opacity="0.2"
          d="M74.2208 93.2168C74.2208 94.2285 73.8189 95.1987 73.1035 95.914C72.3882 96.6294 71.418 97.0312 70.4063 97.0312H63.1773C64.9642 96.7069 66.5806 95.7655 67.7443 94.3713C68.9081 92.977 69.5453 91.2185 69.545 89.4023H70.4063C71.418 89.4023 72.3882 89.8042 73.1035 90.5196C73.8189 91.2349 74.2208 92.2051 74.2208 93.2168V93.2168ZM52.1954 49.7812V54.9492C52.1954 55.9935 51.7805 56.995 51.0421 57.7335C50.3037 58.4719 49.3022 58.8867 48.2579 58.8867H42.498C44.2061 58.1227 45.6139 56.8157 46.5026 55.1691C47.3914 53.5225 47.7112 51.6284 47.4125 49.7812H52.1954ZM82.2188 56.918V64.3008C82.219 65.8033 81.8371 67.2811 81.109 68.5954C80.381 69.9096 79.3306 71.0171 78.0567 71.8138C76.7827 72.6104 75.3272 73.0699 73.8268 73.1492C72.3264 73.2284 70.8305 72.9248 69.4798 72.2668C72.689 71.0713 75.3617 68.7623 77.0105 65.7607C78.6594 62.7591 79.1746 59.2649 78.4622 55.9151C78.4806 55.9287 78.5003 55.9397 78.5188 55.9521C79.5241 56.5834 80.6872 56.9182 81.8743 56.918H82.2188Z"
          fill="#4C004A"
        />
        <path
          opacity="0.2"
          d="M86.0332 51.2579V57.2577C85.5298 57.0333 84.9847 56.9175 84.4336 56.9181H81.8742C80.8273 56.9184 79.7968 56.658 78.8757 56.1605C77.9546 55.663 77.1718 54.944 76.598 54.0683C77.8713 53.0009 78.8748 51.6481 79.5267 50.1197C80.1786 48.5914 80.4606 46.9308 80.3497 45.2729L82.1892 45.8956C83.3101 46.2753 84.2838 46.9969 84.9733 47.9588C85.6629 48.9206 86.0335 50.0745 86.0332 51.2579V51.2579ZM94.0312 84.1951V97.0314H75.9286C79.9506 96.0273 83.4573 93.5671 85.77 90.1268C88.0828 86.6864 89.0372 82.5105 88.4486 78.407L89.6311 78.6765C90.8812 78.9619 91.9973 79.6634 92.7967 80.666C93.5961 81.6686 94.0314 82.9129 94.0312 84.1951ZM80.3324 76.5539C79.9519 77.5115 79.3782 78.3804 78.6472 79.1066C77.9161 79.8328 77.0434 80.4006 76.0834 80.7749C75.1233 81.1491 74.0965 81.3217 73.0669 81.2818C72.0373 81.2419 71.0269 80.9905 70.0986 80.5431C71.775 80.2045 73.2512 79.221 74.2094 77.8044C75.1675 76.3878 75.5308 74.6515 75.2211 72.9696C76.3637 72.7238 77.4458 72.2528 78.4043 71.5841V76.1134L80.3324 76.5539Z"
          fill="#4C004A"
        />
      </g>
      <circle cx="65.5" cy="65.5" r="62.5" stroke="#4C004A" stroke-width="6" />
      <defs>
        <clipPath id="clip0_0_1">
          <rect
            width="63"
            height="63"
            fill="white"
            transform="translate(33 36)"
          />
        </clipPath>
      </defs>
    </svg>
  );
  let taskIcon = (
    <svg
      width="131"
      height="131"
      viewBox="0 0 131 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="65.5" cy="65.5" r="62.5" stroke="#4C004A" stroke-width="6" />
      <path
        d="M75.1992 41.081C75.0925 41.7476 75.0392 42.4143 75.0392 43.081C75.0392 49.081 79.8925 53.9316 85.8659 53.9316C86.5325 53.9316 87.1725 53.8543 87.8392 53.7476V75.265C87.8392 84.3076 82.5059 89.6676 73.4392 89.6676H53.7352C44.6659 89.6676 39.3325 84.3076 39.3325 75.265V55.5343C39.3325 46.4676 44.6659 41.081 53.7352 41.081H75.1992ZM75.7352 57.2943C75.0125 57.2143 74.2952 57.5343 73.8659 58.121L67.4152 66.4676L60.0259 60.6543C59.5725 60.3076 59.0392 60.1716 58.5059 60.2276C57.9752 60.3076 57.4952 60.5983 57.1725 61.025L49.2819 71.2943L49.1192 71.5343C48.6659 72.385 48.8792 73.4783 49.6792 74.0676C50.0525 74.3076 50.4525 74.4676 50.9059 74.4676C51.5219 74.4943 52.1059 74.1716 52.4792 73.6676L59.1725 65.0516L66.7725 70.761L67.0125 70.9183C67.8659 71.3716 68.9325 71.161 69.5459 70.3583L77.2525 60.4143L77.1459 60.4676C77.5725 59.881 77.6525 59.1343 77.3592 58.4676C77.0685 57.801 76.4259 57.3476 75.7352 57.2943ZM86.2395 36.3335C89.7861 36.3335 92.6661 39.2135 92.6661 42.7602C92.6661 46.3068 89.7861 49.1868 86.2395 49.1868C82.6928 49.1868 79.8128 46.3068 79.8128 42.7602C79.8128 39.2135 82.6928 36.3335 86.2395 36.3335Z"
        fill="#4C004A"
      />
    </svg>
  );
  let diaryIcon = (
    <svg
      width="131"
      height="131"
      viewBox="0 0 131 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="65.5" cy="65.5" r="62.5" stroke="#4C004A" stroke-width="6" />
      <path
        d="M70.8616 36.1665C71.6554 36.1665 72.2659 36.814 72.2659 37.5848V47.5132C72.2659 53.1557 76.8757 57.7807 82.4623 57.8115C84.7824 57.8115 86.6141 57.8423 88.0184 57.8423L88.5385 57.8401C89.477 57.8329 90.7405 57.8115 91.8344 57.8115C92.5976 57.8115 93.2082 58.4282 93.2082 59.199V83.989C93.2082 91.6357 87.072 97.8332 79.5011 97.8332H55.2007C47.2635 97.8332 40.7915 91.3273 40.7915 83.3107V50.0723C40.7915 42.4257 46.9582 36.1665 54.5597 36.1665H70.8616ZM74.1281 75.9415H57.5209C56.2692 75.9415 55.2313 76.959 55.2313 78.2232C55.2313 79.4873 56.2692 80.5357 57.5209 80.5357H74.1281C75.3798 80.5357 76.4177 79.4873 76.4177 78.2232C76.4177 76.959 75.3798 75.9415 74.1281 75.9415ZM67.8394 60.5248H57.5209C56.2692 60.5248 55.2313 61.5732 55.2313 62.8373C55.2313 64.1015 56.2692 65.119 57.5209 65.119H67.8394C69.091 65.119 70.129 64.1015 70.129 62.8373C70.129 61.5732 69.091 60.5248 67.8394 60.5248ZM76.7145 38.96C76.7145 37.6311 78.3111 36.9713 79.2239 37.9302C82.524 41.3958 88.2907 47.4546 91.5145 50.8401C92.4059 51.7743 91.7526 53.3253 90.4674 53.3283C87.958 53.3376 84.9998 53.3283 82.872 53.3068C79.4956 53.3068 76.7145 50.4978 76.7145 47.0877V38.96Z"
        fill="#4C004A"
      />
    </svg>
  );

  let dueIcon = (
    <svg
      width="131"
      height="131"
      viewBox="0 0 131 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="65.5" cy="65.5" r="62.5" stroke="#4C004A" stroke-width="6" />
      <path
        d="M31.1665 60.7201L64.1665 79.7868C64.7239 80.1086 65.3562 80.278 65.9999 80.278C66.6435 80.278 67.2758 80.1086 67.8332 79.7868L100.833 60.7201C101.389 60.3978 101.85 59.9351 102.171 59.3785C102.491 58.8219 102.66 58.1908 102.66 57.5484C102.66 56.9061 102.491 56.275 102.171 55.7183C101.85 55.1617 101.389 54.6991 100.833 54.3768L67.8332 35.3101C67.2758 34.9883 66.6435 34.8188 65.9999 34.8188C65.3562 34.8188 64.7239 34.9883 64.1665 35.3101L31.1665 54.3768C30.6109 54.6991 30.1497 55.1617 29.8291 55.7183C29.5084 56.275 29.3397 56.9061 29.3397 57.5484C29.3397 58.1908 29.5084 58.8219 29.8291 59.3785C30.1497 59.9351 30.6109 60.3978 31.1665 60.7201V60.7201ZM65.9999 42.7168L91.6665 57.3834L65.9999 72.2334L40.3332 57.5301L65.9999 42.7168ZM97.1665 71.2801L65.9999 89.2834L34.8332 71.2801C34.4169 71.0361 33.9565 70.8767 33.4785 70.8111C33.0005 70.7454 32.5142 70.7747 32.0475 70.8973C31.5808 71.02 31.143 71.2335 30.759 71.5257C30.375 71.8179 30.0525 72.183 29.8099 72.6001C29.5674 73.0186 29.4102 73.4809 29.3472 73.9604C29.2842 74.4399 29.3166 74.9272 29.4427 75.3941C29.5688 75.861 29.7861 76.2984 30.0819 76.681C30.3778 77.0636 30.7464 77.3839 31.1665 77.6234L64.1665 96.6901C64.7239 97.0119 65.3562 97.1813 65.9999 97.1813C66.6435 97.1813 67.2758 97.0119 67.8332 96.6901L100.833 77.6234C101.253 77.3839 101.622 77.0636 101.918 76.681C102.214 76.2984 102.431 75.861 102.557 75.3941C102.683 74.9272 102.716 74.4399 102.653 73.9604C102.59 73.4809 102.432 73.0186 102.19 72.6001C101.947 72.183 101.625 71.8179 101.241 71.5257C100.857 71.2335 100.419 71.02 99.9522 70.8973C99.4855 70.7747 98.9992 70.7454 98.5212 70.8111C98.0432 70.8767 97.5828 71.0361 97.1665 71.2801V71.2801Z"
        fill="#4C004A"
      />
    </svg>
  );

  let paymentDueIcon = (
    <svg
      width="131"
      height="131"
      viewBox="0 0 131 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="65.5" cy="65.5" r="62.5" stroke="#4C004A" stroke-width="6" />
      <path
        d="M97.3906 42.375H34.6094C32.127 42.375 30.141 44.377 30.125 46.8594V89.1406C30.157 91.623 32.127 93.625 34.6094 93.625H97.3906C99.8891 93.625 101.875 91.591 101.875 89.0926V46.9074C101.875 44.409 99.8891 42.375 97.3906 42.375ZM37.348 47.5H94.6359C95.741 47.5 96.5738 48.3168 96.734 49.4219V52.625H35.25V49.3738C35.4102 48.2848 36.259 47.5 37.348 47.5ZM94.652 88.5H37.348C36.243 88.5 35.4102 87.7152 35.25 86.6262V68H96.75V86.5781C96.5898 87.6832 95.741 88.5 94.652 88.5Z"
        fill="#4C004A"
      />
      <path
        d="M40.375 75.6875H71.125V78.25H40.375V75.6875ZM40.375 80.8125H55.75V83.375H40.375V80.8125ZM81.375 75.6875H91.625V83.375H81.375V75.6875Z"
        fill="#4C004A"
      />
    </svg>
  );
  let upArrowIcon = (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="float-right mt-4 mr-4"
    >
      <path d="M0 12L12 0L24 12H0Z" fill="black" />
    </svg>
  );
  let plusIcon = (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="float-right mr-10"
    >
      <path
        d="M21.9998 3.6665C11.8908 3.6665 3.6665 11.8908 3.6665 21.9998C3.6665 32.1088 11.8908 40.3332 21.9998 40.3332C32.1088 40.3332 40.3332 32.1088 40.3332 21.9998C40.3332 11.8908 32.1088 3.6665 21.9998 3.6665ZM31.1665 23.8332H23.8332V31.1665H20.1665V23.8332H12.8332V20.1665H20.1665V12.8332H23.8332V20.1665H31.1665V23.8332Z"
        fill="#4C004A"
      />
    </svg>
  );
  const [Widget, setWidget] = useState([]);
  // Track widget input
  const [widgetInput, setwidgetInput] = useState();
  // show/hide modal
  const [open, setopen] = useState(false);
  // page refresh
  const [pageRef, setpageRef] = useState(false);

  // refresh page and get all widgets
  useEffect(() => {
    getAllWidgets();
  }, [pageRef]);

  // get all widgets
  let valuesarr = []; // store only unique values
  const getAllWidgets = () => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.startsWith("_id")) {
        const value = localStorage.getItem(key);
        let values = JSON.parse(value);
        if (!valuesarr.includes(values)) {
          valuesarr.push(values);
        }
      }
    }
    setWidget(valuesarr);
  };
  // add a widget
  const addWidget = () => {
    const itemId =
      "_id" +
      new Date().getTime().toString() +
      Math.random().toString(36).substring(2);
    console.log("widgetInput", widgetInput);
    localStorage.setItem(
      itemId,
      JSON.stringify({ id: itemId, ...widgetInput })
    );
    setopen(false);
    setpageRef(!pageRef);
  };
  const removeWidget = (id) => {
    localStorage.removeItem(id);
    setpageRef(!pageRef);
  };
  //
  const options = [
    "patientIcon",
    "patientTodayIcon",
    "taskIcon",
    "diaryIcon",
    "dueIcon",
    "paymentDueIcon",
  ];
  const onOptionChangeHandler = (event) => {
    setwidgetInput({
      ...widgetInput,
      iconType: event.target.value,
    });
  };
  return (
    <div className="grid grid-cols-12">
      {/* sidebar */}
      <div className="grid col-span-2">
        <Sidebar acitveRoute={"dashboard"} />
      </div>
      {/* component */}
      <div className="col-span-10">
        <Header />
        <br />
        <div className="flex justify-between p-10 ">
          <h1 className="text-3xl font-semibold">Dashboard</h1>
          <button
            onClick={() => setopen(!open)}
            className="bg-[#4C004A] hover:bg-[#544354] text-white font-bold py-2 px-4 rounded"
          >
            +Add Widget
          </button>
        </div>
        <br />
        <div className="grid grid-cols-3 gap-8 p-10">
          {/*NHS patient widget */}
          {Widget &&
            Widget.map((val, index) => (
              <div
                key={index}
                className="bg-[#DFE9FE] flex justify-evenly py-10 rounded-md shadow-sm col-span-3 md:col-span-1 relative"
              >
                {val.iconType === "patientIcon"
                  ? patientIcon
                  : val.iconType === "patientTodayIcon"
                  ? patientTodayIcon
                  : val.iconType === "taskIcon"
                  ? taskIcon
                  : val.iconType === "diaryIcon"
                  ? diaryIcon
                  : val.iconType === "dueIcon"
                  ? dueIcon
                  : val.iconType === "paymentDueIcon"
                  ? paymentDueIcon
                  : null}
                {/* patient icon */}
                <span
                  onClick={() => removeWidget(val.id)}
                  className="bg-gray-400 absolute top-3 right-3 text-white rounded-full px-3 py-1 cursor-pointer hover:bg-gray-500"
                >
                  X
                </span>
                {/* heading NHS Patients */}
                <div>
                  <h3 className="text-2xl">{val.title}</h3>
                  <br />
                  <h1 className="text-3xl font-semibold">{val.no}</h1>
                  <br />
                  <h2 className="text-2xl">{val.date}</h2>
                </div>
              </div>
            ))}
          {/* modal */}
          {/* <!--  modal for insert widgets --> */}
          {open && (
            <div className="fixed top-[20%] left-[70%] z-50 w-full p-4 overflow-x-hidden overflow-y-auto h-modal md:h-full">
              <div className="relative w-full h-full max-w-md md:h-auto">
                {/* <!-- Modal content --> */}
                <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                  <button
                    type="button"
                    className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                    onClick={() => setopen(false)}
                  >
                    <svg
                      aria-hidden="true"
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <span className="sr-only">Close modal</span>
                  </button>
                  <div className="px-6 py-6 lg:px-8">
                    <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">
                      Add a new Widget
                    </h3>
                    <div>
                      <label
                        htmlFor="title"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Widget title
                      </label>
                      <input
                        onChange={(e) =>
                          setwidgetInput({
                            ...widgetInput,
                            title: e.target.value,
                          })
                        }
                        type="text"
                        name="title"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:bg-[#4C004A]focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Title"
                        required
                      />
                    </div>
                    <label
                      htmlFor="Number"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Widget Number
                    </label>
                    <input
                      onChange={(e) =>
                        setwidgetInput({ ...widgetInput, no: e.target.value })
                      }
                      type="Number"
                      name="Number"
                      id="Number"
                      placeholder="Widget Number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    />

                    <h3>Select icon Type:</h3>

                    <select onChange={onOptionChangeHandler}>
                      <option>Please choose one option</option>
                      {options.map((option, index) => {
                        return <option key={index}>{option}</option>;
                      })}
                    </select>
                    <br />
                    <br />
                    <button
                      onClick={addWidget}
                      className="w-full text-white bg-[#4C004A] hover:bg-[#4C004A] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-[#4C004A] dark:hover:bg-[#4C004A] dark:focus:bg-[#4C004A]"
                    >
                      Add Widget
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>{" "}
        <br />
        <div className="grid grid-cols-3 gap-5">
          <div className="col-span-3 lg:col-span-1 bg-white">
            {/* Graph */}
            <PieChart highcharts={Highcharts} options={chartOptions} />
            {/* uparrow icon */}
            {upArrowIcon}
          </div>
          {/* Sales summary */}
          <div className="col-span-3 lg:col-span-2 bg-white p-4">
            <div className="grid grid-cols-3">
              {/* row1 */}
              <h1 className="text-2xl font-semibold">Sales summary</h1>
              <select className="w-36 h-12 bg-blue-100 border outline-none border-blue-500 rounded-md text-xl text-blue-700">
                <option className="bg-white" value="All staff">
                  All staff
                </option>
                <option className="bg-white" value="All staff">
                  All staff2
                </option>
                <option className="bg-white" value="All staff">
                  All staff3
                </option>
              </select>
              <div className="text-right mb-5">
                {upArrowIcon}
                {plusIcon}
              </div>
              {/* row1 ends */}
              <hr className="col-span-3 mb-4" />
              {/* row2 start */}
              <p className="text-xl">Total sales</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row2 ends */}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">PX Payment</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">NHS Eye Tests</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">NHS Vouchers</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">Crop Vouchers</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">VAT</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">Money In</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">Cash</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">Debit Card</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
              {/* repeation start */}
              <hr className="col-span-3 my-4" />
              {/* row start */}
              <p className="text-xl">Others</p>
              <p className="text-center text-xl text-[#0AB39C] bg-[#6aaaa228] w-14 space-x-3 rounded-md">
                $0.00
              </p>
              <div className="relative">
                <span className="absolute right-10 text-xl">06/1/2023</span>
              </div>
              {/* row ends */}
              {/* Reption end*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
